var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Page404 text-center"},[_c('r-e-empty',{attrs:{"description":"升级中，请耐心等待！"}},[_c('el-link',{on:{"click":function($event){return _vm.$router.push('/')}}},[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" 点击返回主页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }